import { ServiceBase } from '../../../../../core/services/ServiceBase'
import IndustryProxy from '../proxies/IndustryProxy'

class IndustryService extends ServiceBase {
  getReportYear(params) {
    return this.getData(() => IndustryProxy.getReportYear(params))
  }
}

export default new IndustryService()
